module.exports = __webpack_public_path__ + "img/工作台.fd407ffa.fd407ffa.svg";